import React from 'react';
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ConfirmDeleteDialogProps {
  onClose: () => void;
  data: {
    itemType: string;
    itemName: string;
  };
  onSave: (confirmed: boolean) => void;
}

export function ConfirmDeleteDialog({ onClose, data, onSave }: ConfirmDeleteDialogProps) {
  const { itemType, itemName } = data;
  
  const handleConfirm = () => {
    onSave(true);
  };
  
  const handleCancel = () => {
    onClose();
  };
  
  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Delete {itemType}</DialogTitle>
        <DialogDescription>
          Are you sure you want to delete {itemType} "{itemName}"? This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="destructive" onClick={handleConfirm}>
          Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  );
}
